import * as React from 'react';

// Material UI
import Grid from '@mui/material/Grid2';
import { Typography, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
// Material UI Form
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
// Material UI Modal
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// Estilos 
import { styled } from '@mui/material/styles';

// Icons UI
import CloseIcon from '@mui/icons-material/Close';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function EditSeccion(params) {

    let baseReset = {
        tipo: "seccion",
        nombre: "",
        piso: "",
    }

    const [baseArticulo, setBaseArticulo] = React.useState({
        tipo: "seccion",
        nombre: "",
        piso: "",
    })

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => { setOpen(true); setBaseArticulo(params.edit); } // setBase(params.edit);
    const handleClose = () => setOpen(false);

    const handleCancel = () => {
        setBaseArticulo({ ...baseReset })
        handleClose()
    }

    const handleEditData = (e) => {
        const { id, value } = e.target;
        const tb = { ...baseArticulo };

        switch (id) {


            case "nombre":
                tb.nombre = value; // Eliminar espacios innecesarios
                break;
            case "piso":
                tb.piso = value; // Eliminar espacios innecesarios
                break;
            default:
                console.warn(`Campo no manejado: ${id}`);
                break;
        }

        setBaseArticulo(tb); // Actualizar estado con el cambio
    }

    const handleAceptar = () => {
        if (!baseArticulo.nombre) {
            params.toast.error('Te falta agregar el nombre.')
            return false
        } else if (!baseArticulo.piso) {
            params.toast.error('Te faltan el piso.')
            return false
        }

        params.handleEditArticle(params.articleId, baseArticulo)
        setBaseArticulo(baseReset)
        handleClose()

    }

    return (
        <div>
            <IconButton onClick={handleOpen} color="blueRA" aria-label="add to shopping cart">
                <BorderColorIcon />
            </IconButton>

            <BootstrapDialog
                maxWidth='md'
                // fullScreen
                open={open}
                onClose={handleClose}
            >
                {/* HEADER */}
                <DialogTitle>Agregar Seccion</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                {/* BODY */}
                <DialogContent dividers className='barscroll pb-10'>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
                            <Grid size={{ xs: 12, sm: 12, md: 12 }} className="flex items-center">
                                <Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} className="flex items-center">
                                        <Typography color={"blueRA"} className='ml-4'>Datos Generales:</Typography>
                                    </Grid>
                                    <Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
                                        <TextField
                                            fullWidth
                                            id="nombre"
                                            name="nombre"
                                            label="Nombre"
                                            variant="outlined"
                                            type='text'
                                            color={"blueRA"}
                                            size="small"
                                            inputProps={{ min: 1 }}
                                            value={baseArticulo.nombre}
                                            onChange={handleEditData}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
                                        <TextField
                                            fullWidth
                                            id="piso"
                                            name="piso"
                                            label="Piso"
                                            variant="outlined"
                                            type='text'
                                            color={"blueRA"}
                                            size="small"
                                            inputProps={{ min: 1 }}
                                            value={baseArticulo.piso}
                                            onChange={handleEditData}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                {/* FOOTER */}
                <DialogActions className='flex justify-between px-5'>
                    <div></div>
                    <div>
                        <Button className='mr-5' color='ochre' variant="contained" onClick={handleAceptar}>Aceptar</Button>
                        <Button color='error' variant="outlined" onClick={handleCancel}>Cancelar</Button>
                    </div>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}